import { LeadColumn, DEFAULT_COLUMN_IDS } from "../../../../types/LeadTypes";

const DEFAULT_ID_SET = new Set<string>(DEFAULT_COLUMN_IDS as readonly string[]);

export const columnLabel = (
  column: LeadColumn,
  t: (key: string) => string
): string => {
  if (DEFAULT_ID_SET.has(column.id)) {
    const translated = t(`leads.status.${column.id}`);
    return translated && translated !== `leads.status.${column.id}`
      ? translated
      : column.label;
  }
  return column.label;
};

export const resolveColumnId = (
  leadColumnId: string | undefined,
  columns: LeadColumn[]
): string => {
  if (leadColumnId && columns.some((c) => c.id === leadColumnId))
    return leadColumnId;
  return columns[0]?.id ?? "";
};
